import React, { useState, useEffect } from "react";
import SuccessModel from "../Popup copy/SuccessModel";
import { SelectPopup } from "../Popup copy/SelectPopup";

function SearchPopup({ isOpen, onClose }) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedHsn, setSelectedHsn] = useState("");
  const [relatedHsn, setRelatedHsn] = useState("");

  useEffect(() => {
    if (isOpen) {
      setShowSuccess(false);
      setShowPopup(false);
    }
  }, [isOpen]);

  // Ensure only one modal is active
  if (!isOpen && !showSuccess && !showPopup) return null;

  const handleAdd = () => {
    setShowSuccess(true); // show success modal
    setShowPopup(false);  // close select popup if open
    onClose();            // close SearchPopup
  };

  const handleSelectClick = () => {
             // close SearchPopup
    setShowPopup(true);  // open SelectPopup
  };

  const handleDeleteClickWithData = (hsnCode) => {
    setSelectedHsn(hsnCode);
    setRelatedHsn(`Related to ${hsnCode}`);
    setShowPopup(false); // close SelectPopup after selection
  };

  return (
    <>
      {/* Main Search Popup */}
      {!showSuccess && isOpen && !showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="p-6 rounded-xl shadow-xl w-full max-w-[600px] bg-white">
            <div className="flex justify-between items-center mt-1">
              <h3 className="text-lg text-gray-900">Edit Link Unit to SAC</h3>
              <button onClick={onClose} className="text-gray-600 text-2xl">
                &times;
              </button>
            </div>
            <hr />
            <div className="space-y-4 mt-5">
              <div>
                <label className="flex text-gray-700">
                  SAC<span className="text-red-500">*</span>
                </label>
                <div className="max-w-[400px] mt-1 border px-3 py-2 rounded">
                  <div className="flex justify-between">
                    <div className="text-gray-400">
                      {selectedHsn || "Select Hsn"}
                    </div>
                    <span
                      className="text-gray-500 text-sm cursor-pointer"
                      onClick={handleSelectClick}
                    >
                      ▼
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <label className="flex text-gray-700">
                  Default SAC<span className="text-red-500">*</span>
                </label>
                <div className="max-w-[400px] mt-1 border px-3 py-2 rounded">
                  <div className="flex justify-between">
                    <div className="text-gray-400">Enter Unit</div>
                  </div>
                </div>
              </div>

              <div>
                <label className="flex text-gray-700">
                  Other Allowed Unit <span className="text-red-500">*</span>
                </label>
                <textarea
                  rows="3"
                  value={relatedHsn}
                  onChange={(e) => setRelatedHsn(e.target.value)}
                  placeholder="Enter Related Products HSN code …Use ( , ) for multiple HSN"
                  className="w-full h-40 mt-1 border px-3 py-2 rounded focus:outline-none"
                />
              </div>
            </div>

            <div className="flex justify-end mt-4">
              <button
                className="bg-blue-600 text-white px-10 py-1 rounded"
                onClick={handleAdd}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccess && (
        <SuccessModel
          onClose={() => {
            setShowSuccess(false);
          }}
        />
      )}

      {/* SelectPopup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <SelectPopup
            onClose={() => setShowPopup(false)}
            onDeleteClickWithData={handleDeleteClickWithData}
          />
        </div>
      )}
    </>
  );
}

export default SearchPopup;
